import React, { useState } from 'react'
import StepWizard, { StepWizardChildProps } from 'react-step-wizard'

import { WIZARD_STEPS_MAPPING } from 'containers/Apply/LongBeachWizard'
import { updatePercentageAndStep } from 'v2/components/XProgressBar/utils'

import ACPBenefitsHow from './ACPBenefitsHow'

interface Props {
    step?: number
    personId?: any
    onAcpOptionOne: (value: boolean) => void
    onFinish: () => void
    backwardsStep?: boolean
    updatePercentage: any
}

const ACPWizardContainer: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const [currentStep, setCurrentStep] = useState<number>(1)

    const { percentage, wizardStep, childWizzardStep } = updatePercentageAndStep(
        WIZARD_STEPS_MAPPING.benefits,
        WIZARD_STEPS_MAPPING.benefits.acp,
        WIZARD_STEPS_MAPPING
    )
    props.updatePercentage(percentage, wizardStep, childWizzardStep)

    return (
        <React.Fragment>
            <StepWizard
                initialStep={currentStep}
                transitions={{
                    enterRight: '',
                    enterLeft: '',
                    exitRight: '',
                    exitLeft: '',
                }}
                isLazyMount={true}
                onStepChange={(stepInfo: { previousStep: number; activeStep: number }) => {
                    setCurrentStep(stepInfo.activeStep)
                }}
            >
                <ACPBenefitsHow
                    personId={props.personId}
                    onPrevious={props.previousStep}
                    onFinish={props.onFinish}
                    onAcpOptionOne={props.onAcpOptionOne}
                />
            </StepWizard>
        </React.Fragment>
    )
}

export default ACPWizardContainer
